import React, { FC } from "react";
import { Card, Col, Row, Spin } from "antd";
import { Link } from "react-router-dom";
import moment from "moment";
import { EyeOutlined } from "@ant-design/icons";

import useHttpGet from "../../../hooks/useHttpGet";
import { APIRoutes } from "../../../http";
import { IBlog } from "../../../models/blog.model";
import { IResultListResponse } from "../../../models/response/result-list.model";
import { UIRoutes } from "../../../router";
import { IResultResponse } from "../../../models/response/result.model";
import { IAdBlock } from "../../../models/ad-block.model";
import { MagicPagesTypes } from "../../../services/enums";
import CommonService from "../../../services/common.service";
import { BASE_IMAGE_URL } from "../../../services/constants";

const Blog: FC = () => {
  const { fetchedData, loading } = useHttpGet<IResultListResponse<IBlog>>(
    `${APIRoutes.BLOG}`,
    {
      defaultValue: {} as IResultListResponse<IBlog>,
    }
  );

  const { fetchedData: sponsorsData, loading: sponsorsLoading } = useHttpGet<
    IResultResponse<IAdBlock[]>
  >(`${APIRoutes.AD_BLOCKS}/${MagicPagesTypes.Blog}`, {
    dependencies: [],
    defaultValue: { result: [] as IAdBlock[] },
  });

  return (
    <Row justify="center" align="top">
      <Col xs={24} sm={24} md={20}>
        <Card
          className="custom-card-1"
          title={
            <div className="d-flex align-items-center">
              <span className="mr-0_5 fs-36">Blog</span>
            </div>
          }
          loading={loading}
        >
          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
            <Col xs={24} sm={16} md={20}>
              <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                {fetchedData.result?.list?.map((el: IBlog) => (
                  <Col xs={24} sm={12} md={8} key={el.id}>
                    <Card
                      title={
                        <Link
                          to={`/${
                            UIRoutes.VIEW_BLOG_BASE
                          }/${CommonService.replaceSymbol(el.title)}/${el.id}`}
                        >
                          {el.title}
                        </Link>
                      }
                      cover={
                        <img
                          alt="example"
                          src={`${BASE_IMAGE_URL}/img/${el.image}`}
                        />
                      }
                      actions={[
                        <span>{moment(el.createdOn).format("LLLL")}</span>,
                        <span>
                          <EyeOutlined /> {el?.watchCount}
                        </span>,
                      ]}
                      className="mb-1 mt-1 custom-card-1"
                      key={el.id}
                      bordered={false}
                    >
                      <div
                        dangerouslySetInnerHTML={{
                          __html: el.shortDescription,
                        }}
                        className="pt-0_5"
                      />
                    </Card>
                  </Col>
                ))}
              </Row>
            </Col>
            <Col xs={24} sm={8} md={4}>
              <Spin spinning={sponsorsLoading}>
                {sponsorsData.result.map((el: IAdBlock) => (
                  <div
                    key={el.id}
                    dangerouslySetInnerHTML={{ __html: el.code }}
                    className="pt-0_5"
                  />
                ))}
              </Spin>
            </Col>
          </Row>
        </Card>
      </Col>
    </Row>
  );
};

export default Blog;
